export const environment = {
  production: false,
  staging: true,
  apiUrl: 'https://staging.taptimize.com/api',
  appName: 'Taptimize MK2 - Staging',
  version: '1.0.0'
}; 